/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import Container from "../../../../../components/Container/Container";
import AttorneySection from "../../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { contractTeaserCards } from "../../../../../services/landingPageService";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import CivilLawCheckin from "../../../../../components/Checkin/CivilLawCheckin/CivilLawCheckin";
import LpCivilLawAdvocardMeta from "./LpCivilLawAdvocardMeta";
import HowItWorksSectionCivilLaw from "../../../../../components/Sections/CivilLaw/HowItWorksSection/HowItWorksSectionCivilLaw";
import { PARTNER_IRIS } from "../../../../../constants/partnerIris";

const LpCivilLawAdvocard = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      <LpCivilLawAdvocardMeta />
      <LandingPageTeaser
        teaserButtonText={"Jetzt Starten"}
        headline={"Fragen oder Probleme bei rechtlichen Streitigkeiten im Alltag?"}
        subheadline={"Wir sorgen dafür, dass Sie zu Ihrem Recht gelangen!"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={contractTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ADVOCARD} containerStyle={"settlementContainer"} />
      <GreyBackgroundWrapper>
        {!isLoggedIn && (
          <Container>
            <CivilLawCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
          </Container>
        )}
        <HowItWorksSectionCivilLaw />
      </GreyBackgroundWrapper>
      <AttorneySection
        textCards={false}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
        heading={"Deutschlandweit tätige Partneranwälte"}
      />
      {!isLoggedIn && (
        <Container>
          <CivilLawCheckin idPrefix={"top"} partner={PARTNER_IRIS.ADVOCARD} />
        </Container>
      )}
    </Layout>
  );
};

export default LpCivilLawAdvocard;
